import savingsIcon from '../assets/icon-savings.svg';

interface SavingsBadgeProps {
  percent: number;
  /** `compact` = Figma "SAVE N%" pill on the single-plan price row. */
  variant?: 'sheet' | 'compact';
}

/** Red savings pill. Sheet copy is used in the card payment sheet. */
export function SavingsBadge({ percent, variant = 'sheet' }: SavingsBadgeProps) {
  return (
    <span
      className={
        variant === 'compact'
          ? 'flex items-center gap-1 rounded-full bg-mf-error px-2 py-1 text-[10px] font-bold leading-3 text-white'
          : 'flex items-center gap-1 rounded-full bg-mf-error px-2 py-1 text-[10px] font-medium leading-3 text-white'
      }
    >
      <img src={savingsIcon} alt="" className="h-3 w-2.5" />
      {variant === 'compact' ? `SAVE ${percent}%` : `You just saved ${percent}%`}
    </span>
  );
}
